import React from "react";
import './Sidepanel.css'
import TwitchChat from './twitch-chat';
import Customization from './Customization';
import DigitalShop from './DigitalShop';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import ChatOnTab from './images/sidepanel-chat-active.png';
import ShopTab from './images/sidepanel-shop-active.png';
import CustomOnTab from './images/sidepanel-custom-active.png';
import { useAuth0 } from "@auth0/auth0-react";


const Sidepanel = ({ twitch_channel, wallets, setWallets, sidePanelTabsIndex, setSidePanelTabsIndex }) => {
    const { isAuthenticated } = useAuth0();
    return (
        <Tabs forceRenderTabPanel={true} className="sidepanel" selectedTabClassName="sidepanel_tab--selected" selectedTabPanelClassName="sidepanel_tab-panel--selected" selectedIndex={sidePanelTabsIndex} onSelect={(index) => setSidePanelTabsIndex(index)}>
            { isAuthenticated &&
            <TabList className="sidepanel_tabs">
                <Tab className="sidepanel_tab"><img src={ChatOnTab} alt="Chat Room Tab" /></Tab>
                {/* <Tab className="sidepanel_tab"><img src={ShopTab} alt="Digital Shop Tab" /></Tab> */}
                <Tab className="sidepanel_tab"><img src={CustomOnTab} alt="Customize Tab" /></Tab>
            </TabList>
            }
            <TabPanel className="sidepanel_tab-panel">
                <TwitchChat twitch_channel={twitch_channel} />
            </TabPanel>
            {/* <TabPanel className="sidepanel_tab-panel">
                <DigitalShop />
            </TabPanel> */}
            <TabPanel className="sidepanel_tab-panel">
                <Customization wallets={wallets} setWallets={setWallets} />
            </TabPanel>
        </Tabs>
    );
};

export default Sidepanel;
